export default function mapProfileToProps({ profile: { view } }) {
  if (!view.data) {
    return null;
  }

  /* remove empty values that come from the backend (that's a limitation from Elastic Search) */
  const isValidObj = (s) => Object.keys(s).length > 0
  const specializations = view.data.specializations.filter(isValidObj)
  const testimonials = view.data.testimonials.filter(isValidObj)

  return {
    ...view,
    ...view.data,
    specializations,
    testimonials
  };
}



// WEBPACK FOOTER //
// ./profile/containers/map_profile_to_props.js